/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DisableUserUsageLimit200ResponseReissueOneOf1
 */
export interface DisableUserUsageLimit200ResponseReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseReissueOneOf1
     */
    'cardType': DisableUserUsageLimit200ResponseReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200ResponseReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const DisableUserUsageLimit200ResponseReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type DisableUserUsageLimit200ResponseReissueOneOf1CardTypeEnum = typeof DisableUserUsageLimit200ResponseReissueOneOf1CardTypeEnum[keyof typeof DisableUserUsageLimit200ResponseReissueOneOf1CardTypeEnum];


